module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAARhJREFUOE+l078rR1EYx/HXt5S/QmaxWFkYLJIfJZskg4VNYTMqNhNlMFgsfqwGFv4BvwaLYjcrxX1u99RxXX3JqTOc83zez3nOeT6n5R+j1cAOYxG96MMt7rCLi1xfh/fRg208VDPWMVeq9UJKkMMBPheBjSz7EC6zdcRGMBh7CR7HGgYy4SNeCjgS5Iec4ADHafMIhzit4FW8Yg/rxX4/ZqrYBGaLt5hO8D1G8dTwgFFqN+az2Bs6E/xRKy3pAgxoDDcZXOrbnRyiaFlUlo8vJ9fvnITL2KmB3+48hTlM1oSRND1UCl1jE2d5C66K/p3/os9dhR9Ko/zksDJzVkXyQbiu0WFJGy1bqpzUgfeqoq123v7TH/sEDic5EAPgAwkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AK.png
// module id = ogTW
// module chunks = 5